import { render, staticRenderFns } from "./FormSummary.vue?vue&type=template&id=0c38d382&scoped=true&"
import script from "./FormSummary.vue?vue&type=script&lang=ts&"
export * from "./FormSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c38d382",
  null
  
)

export default component.exports